export default __webpack_public_path__ + "static/media/sumit.0d89df46.svg";